var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVideoSetScormUnpublish = function SvgIconVideoSetScormUnpublish(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.333 14.667h-.182c-2.173 0-3.261 0-4.016-.532a2.7 2.7 0 0 1-.57-.536C2 12.888 2 11.865 2 9.819V8.122c0-1.975 0-2.963.313-3.752.502-1.269 1.565-2.269 2.913-2.742.837-.294 1.886-.294 3.986-.294 1.199 0 1.799 0 2.277.168.77.27 1.378.842 1.665 1.567.18.45.18 1.015.18 2.144v3.454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2 8A2.22 2.22 0 0 1 4.222 5.78c.444 0 .967.077 1.399-.038a1.11 1.11 0 0 0 .786-.787c.115-.431.038-.955.038-1.399a2.22 2.22 0 0 1 2.222-2.221"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    d: "m10 11 3 3M10 14l3-3"
  })));
};
export default SvgIconVideoSetScormUnpublish;